import { Button } from '@monksflow/monks-ui';

import { allSelected } from '../lib/library-selection';

/**
 * Takes a whole section into the selection in one click, and gives it back in the next.
 *
 * The bar's own checkbox reaches everything on screen, which is the wrong grain for a library that
 * draws two kinds at once: emptying the pictures is not a reason to lose the typefaces with them.
 * A control per section is what makes "all the media" and "all the fonts" two separate asks, and it
 * sits in the section heading because that is where the count it is about to select is printed.
 *
 * Words rather than a checkbox, unlike the bar's: a box in a heading reads as the state of the
 * section, and this is a thing to do to it. Its label says which of the two it will take, so the
 * pair are told apart by anybody reading them out as well as by anybody looking at them.
 *
 * Drawn only when the section holds something. A control that could select nothing is a control
 * that has nothing to say, and disabled it would still claim the heading's only slot.
 */
export const SelectSectionButton = ({
  label,
  clearLabel,
  keys,
  selection,
  onToggle,
}: {
  label: string;
  /** What it says once the whole section is in the selection, which is when it undoes itself. */
  clearLabel: string;
  /** The section's rows, as selection keys. */
  keys: readonly string[];
  selection: ReadonlySet<string>;
  onToggle: () => void;
}) => {
  if (keys.length === 0) return null;

  return (
    <Button variant="ghost" size="sm" onClick={onToggle}>
      {allSelected(selection, keys) ? clearLabel : label}
    </Button>
  );
};
